/* JHSN cart drawer (Icons Footwear): reservation timer, upsell add, shipping protection, header count. VIP+ membership line is excluded from counts. */

/* ---------- Helpers: variant ids of system lines (shipping protection, VIP+) ---------- */
window.jhsnSystemIds = function () {
  const d = document.getElementById('CartDrawer');
  const ids = [];
  if (d) {
    ['data-protection-variant', 'data-vip-variant'].forEach((a) => {
      const v = parseInt(d.getAttribute(a), 10);
      if (v) ids.push(v);
    });
  }
  return ids;
};

/* ---------- Header count (excludes shipping protection and VIP+) ---------- */
if (!customElements.get('jc-cart-count')) {
  customElements.define(
    'jc-cart-count',
    class JcCartCount extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
        const unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
          const cart = event && event.cart;
          if (!cart || cart.errors) return;
          const sys = window.jhsnSystemIds();
          let count = cart.item_count || 0;
          if (Array.isArray(cart.items)) {
            count = cart.items.filter((i) => sys.indexOf(i.variant_id) === -1).reduce((sum, i) => sum + i.quantity, 0);
          }
          this.textContent = String(count);
        });
        this.registerCleanup(unsubscribe);
      }
    }
  );
}

/* ---------- Upsell add ("Complete the look") ---------- */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends BaseElement {
      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      connectedCallback() {
        super.connectedCallback();
        this.on(this, 'click', this.onClick.bind(this));
      }

      showError(message) {
        const error = this.querySelector('.jc-up__error');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      }

      async onClick(event) {
        const button = event.target.closest('[data-upsell-add]');
        if (!button || button.getAttribute('aria-disabled') === 'true') return;

        const card = button.closest('.jc-up__card');
        const select = card && card.querySelector('select');
        const id = select ? select.value : button.getAttribute('data-variant-id');

        button.setAttribute('aria-disabled', 'true');
        this.showError('');

        try {
          const body = JSON.stringify({
            items: [{ id: parseInt(id, 10), quantity: 1 }],
            sections: [this.sectionId],
            sections_url: window.location.pathname
          });
          const added = await (await fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })).json();

          if (added.status) {
            this.showError(added.description || added.message);
            button.removeAttribute('aria-disabled');
            return;
          }

          const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
          cartJson['sections'] = added['sections'];
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cart: cartJson });
        }
        catch (error) {
          console.error(error);
          this.showError('Sorry, we could not add this product. Please try again.');
          button.removeAttribute('aria-disabled');
        }
      }
    }
  );
}

/* ---------- Shipping protection checkbox (variant of product "shipping-protection") ---------- */
if (!customElements.get('cart-protection')) {
  customElements.define(
    'cart-protection',
    class CartProtection extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
        this.on(this, 'change', this.onChange.bind(this));
      }

      async onChange(event) {
        const input = event.target.closest('input[type="checkbox"]');
        if (!input) return;

        const variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        const sectionId = this.getAttribute('data-section-id');
        const wanted = input.checked;
        input.disabled = true;

        try {
          let cart;
          if (wanted) {
            const added = await (await fetch(theme.routes.cart_add_url, {
              ...theme.utils.fetchConfig('javascript'),
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: [sectionId], sections_url: window.location.pathname })
            })).json();
            if (added.status) throw new Error(added.description || 'add failed');
            cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cart['sections'] = added['sections'];
          }
          else {
            cart = await (await fetch(theme.routes.cart_change_url, {
              ...theme.utils.fetchConfig(),
              body: JSON.stringify({ id: String(variantId), quantity: 0, sections: [sectionId], sections_url: window.location.pathname })
            })).json();
            if (cart.status) throw new Error(cart.description || 'change failed');
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-protection', cart });
        }
        catch (error) {
          console.error(error);
          input.checked = !wanted;
          input.disabled = false;
        }
      }
    }
  );
}

/* ---------- Reservation timer (non-restarting) + system-lines-only cleanup ---------- */
(function () {
  const KEY = 'jhsnCartTimer';
  const FLAG = 'jhsnCartExpired';
  let store = null;
  try {
    localStorage.setItem('__jc', '1');
    localStorage.removeItem('__jc');
    store = localStorage;
  }
  catch (e) { store = null; }

  const drawer = () => document.getElementById('CartDrawer');
  const limit = () => {
    const d = drawer();
    const v = d ? parseInt(d.getAttribute('data-timer-seconds'), 10) : NaN;
    return isNaN(v) ? 600 : v;
  };
  const realCount = (cart) => {
    const sys = window.jhsnSystemIds();
    return (cart.items || []).filter((i) => sys.indexOf(i.variant_id) === -1).reduce((s, i) => s + i.quantity, 0);
  };

  const read = () => {
    if (!store) return null;
    try { return JSON.parse(store.getItem(KEY)); } catch (e) { return null; }
  };
  const write = (value) => { try { store.setItem(KEY, JSON.stringify(value)); } catch (e) { /* ignore */ } };
  const clearState = () => { try { store && store.removeItem(KEY); } catch (e) { /* ignore */ } };
  const flag = (on) => {
    try { on ? sessionStorage.setItem(FLAG, '1') : sessionStorage.removeItem(FLAG); } catch (e) { /* ignore */ }
  };
  const flagged = () => { try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) { return false; } };
  const fmt = (s) => {
    s = Math.max(0, s);
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m < 10 ? '0' : ''}${m}:${r < 10 ? '0' : ''}${r}`;
  };
  const tokenOf = (cart) => String(cart.token || '').split('?')[0];

  let busy = false;

  function applyExpiredMessage() {
    const note = document.querySelector('#CartDrawer .jc-expired');
    if (note) note.hidden = !flagged();
  }

  async function expire() {
    if (busy) return;
    busy = true;
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      clearState();
      flag(true);
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'jhsn-timer', cart: { item_count: 0, items: [] } });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }
    catch (e) { /* retry on next tick */ }
    finally { busy = false; }
  }

  function render() {
    const timers = document.querySelectorAll('[data-jc-timer]');
    if (!store) {
      timers.forEach((el) => { el.hidden = true; });
      return;
    }
    const state = read();
    if (!state) return;
    const left = limit() - Math.floor((Date.now() - state.start) / 1000);
    document.querySelectorAll('[data-jc-time]').forEach((el) => { el.textContent = fmt(left); });
    if (left <= 0) expire();
  }

  async function sync() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const count = realCount(cart);
      document.querySelectorAll('jc-cart-count').forEach((el) => { el.textContent = String(count); });

      if (count === 0) {
        clearState();
        if (cart.item_count > 0 && window.jhsnSystemIds().length) {
          // only system lines (shipping protection / VIP+) are left: remove them so the cart is truly empty
          const sectionId = drawer() && drawer().getAttribute('data-section-id');
          let next = null;
          for (const line of cart.items) {
            next = await (await fetch(theme.routes.cart_change_url, {
              ...theme.utils.fetchConfig(),
              body: JSON.stringify({ id: String(line.variant_id), quantity: 0, sections: sectionId ? [sectionId] : [], sections_url: window.location.pathname })
            })).json();
          }
          if (next && !next.status) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'jhsn-cleanup', cart: next });
        }
        return;
      }

      flag(false);
      applyExpiredMessage();

      if (!store) return;
      const token = tokenOf(cart);
      let state = read();
      if (!state || state.token !== token) {
        state = { token, start: Date.now() };
        write(state);
      }
      render();
    }
    catch (e) { /* ignore */ }
  }

  function init() {
    sync();
    setInterval(render, 1000);
    setInterval(sync, 15000);
    document.addEventListener('cart:updated', sync);

    const d = drawer();
    if (d) {
      new MutationObserver(applyExpiredMessage).observe(d, { childList: true, subtree: true });
      applyExpiredMessage();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
